import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Bathtubs = createSvgIcon(
  <path d="M4.5 4.232c0-1.214.961-1.982 1.982-1.982.61 0 1.366.35 1.735.99l.45.783-2.463 1.369 1.092 1.966 6.75-3.75-1.092-1.966-2.32 1.288-.468-.813C9.342.685 7.782 0 6.482 0 4.396 0 2.25 1.604 2.25 4.232V13.5H0v2.25h1.588a7.103 7.103 0 0 0 1.85 3.76l-1.981 3.3 1.929 1.159 1.846-3.077a7.093 7.093 0 0 0 3.393.858h6.75c1.228 0 2.384-.31 3.393-.858l1.846 3.076 1.93-1.157-1.982-3.302a7.103 7.103 0 0 0 1.85-3.759H24V13.5H4.5V4.232ZM20.12 15.75a4.877 4.877 0 0 1-4.745 3.75h-6.75a4.877 4.877 0 0 1-4.745-3.75h16.24Z" />,
  'Bathtubs'
);

export { Bathtubs };